import Vue from 'vue'
import * as zoid from 'zoid/dist/zoid.frameworks'
import { DriveScout } from './drivescout';

const DriveScoutLogin = zoid.create({

    // The html tag used to render my component
    tag: 'drivescout-login-vue',

    // The url that will be loaded in the iframe or popup, when someone includes my component on their page
    url: 'https://login.drivescout.com/drivescout-login', // 'http://login.drivescout.test/drivescout-login',

    // The size of the component on their page. Only px and % strings are supported
    dimensions: {
        width: '400px',
        height: '450px'
    },

    // The properties they can (or must) pass down to my component. This is optional.
    props: {
        backgroundColor: {
            type: 'string'
        },
        loginHeader: {
            type: 'string'
        },

        errorBackgroundColor: {
            type: 'string'
        },
        errorTextColor: {
            type: 'string'
        },

        forgotPasswordColor: {
            type: 'string'
        },

        buttonBackgroundColor: {
            type: 'string'
        },
        submitButtonText: {
            type: 'string'
        },

        onLogin: {
            type: 'function',
            required: false,
            default: DriveScout.goToDriveScout
        }
    }
});

DriveScoutLogin.driver('vue', Vue)
export {DriveScoutLogin};
